import { get, post, put, destroy } from './base';
export const LandingPageServe = {
    index: (params) =>
        get('/landingpages',{ params}),
    single: (id) =>
        get(`/landingpages/${id}`),
    emailtemplate: (id) =>
        get(`/landingpages/email-template/${id}`),
    create: (payload) =>
        post('/landingpages', payload),
    createByEmail: (payload) =>
        post('/landingpages/email', payload),
    saveform: (payload) =>
        post('/landingpages/saveform', payload),
    update: (id, payload) =>
        put(`/landingpages/${id}`, payload),
    remove: (id) =>
        destroy(`/landingpages/${id}`),
    pocPublishedMail: (payload) => 
        post('/landingpages/poc-published' , payload)
}